
import { Component, Vue } from 'vue-property-decorator';
import config from '@/config';

@Component({
  name: 'RGPDOclubApp',
})
export default class RGPDOclubApp extends Vue {
  mounted() {
    // Redirect to home page if the app name is not O'Club par Tadao
    const name = config.nameApp || "";
    if (name.toLowerCase() !== "tadao") {
      this.$router.push({ path: '/' });
    }
  }
}
